import {
    entityIdSchema,
    familyRoleSchema,
    personNameSchema,
    utcInstantSchema,
} from '@baby-tracker/validation';
import { z } from 'zod';

import { successEnvelope } from './envelope.js';
import { familyPath } from './families.js';

export function membersPath(familyId: string): string {
    return `${familyPath(familyId)}/members`;
}

export function memberPath(familyId: string, userId: string): string {
    return `${membersPath(familyId)}/${userId}`;
}

export const memberSchema = z.object({
    userId: entityIdSchema,
    name: z.string().min(1).max(255),
    email: z.email(),
    role: familyRoleSchema,
    displayName: personNameSchema.nullable(),
    joinedAt: utcInstantSchema,
});

export type Member = z.infer<typeof memberSchema>;

export const memberListSchema = z.array(memberSchema);

export const updateMemberInputSchema = z
    .object({
        role: familyRoleSchema.optional(),
        displayName: personNameSchema.nullable().optional(),
    })
    .refine((value) => value.role !== undefined || value.displayName !== undefined, {
        message: 'At least one field is required',
    });

export type UpdateMemberInput = z.infer<typeof updateMemberInputSchema>;

export const removedMemberSchema = z.object({
    userId: entityIdSchema,
});

export type RemovedMember = z.infer<typeof removedMemberSchema>;

export const memberResponseSchema = successEnvelope(memberSchema);
export const memberListResponseSchema = successEnvelope(memberListSchema);
export const removedMemberResponseSchema = successEnvelope(removedMemberSchema);
